import { CheckEnum } from '@app/core/models/open-api.model';


export enum EnumCheckTypeEnum {
	CheckForKeys = 'checkForKeys',
	CheckForValues = 'checkForValues'
}

export enum ObjectTypeEnum {
	ENUM = 'enum',
	CLASS = 'class'
}


export interface IOpenApiCheckResult {
	modelNameDto: string;

	modelNameTmo: string;

	modelsInSync: boolean;

	countMismatch: number;

	recursivePropsMismatch: string[];

	newDtoProps: string[];

	removedDtoProps: string[];

	enumMismatch: string[];

	resultMessage: string;
}

interface IDtoTmoModelBaseMap {
	dto: any;

	tmo: any;

	checkList: CheckEnum[];

	excludeTmoPropsFromCheckList?: string[];

	excludeDtoPropsFromCheckList?: string[];
}

export interface IDtoTmoModelClassMap extends IDtoTmoModelBaseMap {
	type: ObjectTypeEnum.CLASS;
}

export interface IDtoTmoModelEnumMap extends IDtoTmoModelBaseMap {
	type: ObjectTypeEnum.ENUM;
	tmoEnumName: string;
}

export type IDtoTmoModelMapType =
	IDtoTmoModelClassMap
	| IDtoTmoModelEnumMap;
